// extracted by mini-css-extract-plugin
export default {"container":"infoContainer_container__uq4fx","rightContainer":"infoContainer_rightContainer__z1Dfh"};